import React, { useEffect, useState } from 'react'
import styles from './GetNumber.module.css';
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import decodeToken from "../../lib/decodeToken";
import { API_BASE_URL, getAgentById } from '../../Store/apiStore';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setPaymentCancelReturn } from '../PaymentCancel/PaymentCancel';

const GetNumber = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const features = [
        "Dedicated business phone number",
        "Incoming calls answered by your AI",
        "Call logs included",
    ];

    const token = localStorage.getItem("token") || "";
    const decodeTokenData = decodeToken(token);
    const [loading, setLoading] = useState(false);

    // If agentId is passed via email link, store it + its businessId so NumberAssign can fetch numbers
    useEffect(() => {
        const agentIdFromUrl = searchParams.get("agentId");
        if (!agentIdFromUrl) return;

        sessionStorage.setItem("SelectAgentId", agentIdFromUrl);

        (async () => {
            try {
                const res = await getAgentById(agentIdFromUrl);
                const businessId = res?.data?.businessId;
                if (businessId) {
                    sessionStorage.setItem("SelectAgentBusinessId", businessId);
                }
            } catch (err) {
                console.error("Failed to fetch agent businessId:", err?.response?.data || err?.message);
            }
        })();
    }, [searchParams]);
    const QuickSetupGateway = async () => {
        try {
            setLoading(true);
            if (!decodeTokenData || !token) {
                console.error("User not authenticated");
                return;
            }

            const customerId = decodeTokenData.customerId;
            const userId = decodeTokenData.id;

            const params = new URLSearchParams({ ispayg: "true" });

            const successUrl = `${window.location.origin}/number-assign?${params.toString()}`;
            const cancelUrl = `${window.location.origin}/payment-cancel`;
            // Cancel par user ko WAHIN wapas laana hai jahan se wo checkout pe
            // gaya tha — Stripe ke baad history/in-memory state kuch nahi bachta.
            setPaymentCancelReturn(window.location.pathname + window.location.search);

            const response = await axios.post(
                `${API_BASE_URL}/quick-setup-payg`,
                {
                    customerId,
                    userId,
                    url: successUrl,
                    cancelUrl,
                    isAssignNumber: true,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.checkoutUrl) {
                setLoading(false);
                // navigate(response.data.checkoutUrl, { replace: true });
                // window.location.href = response.data.checkoutUrl;
                window.history.pushState(null, '', '/');
                window.location.replace(response.data.checkoutUrl);
            }

        } catch (error) {
            console.error("Checkout Error:", error.response?.data || error.message);
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.titleBar} >
                    <h4 className={styles.lightTitle}>Get Phone Number </h4>
                    <h5 className={styles.boldTitle}>for your Agent</h5>
                    <p className={styles.subtitle}>
                        This number lets your AI receptionist answer <span className={styles.boldText}>real customer calls.</span>
                    </p>
                </div>
                <div className={styles.priceBar}>
                    <div className={styles.priceBarSection}>
                        <h4 className={styles.Price}><span>$</span>5</h4>
                        <h5 className={styles.Month}>/month</h5>
                    </div>
                    <div className={styles.badges}>
                        <p>Pay only for the phone number.</p>
                    </div>
                    <div className={styles.cancelDiv}><p>Cancel anytime</p></div>
                    <div className={styles.divider}></div>
                    <div className={styles.featuresDiv}>
                        {features.map((text, index) => (
                            <div className={styles.row} key={index}>
                                <div className={styles.circle}>{index + 1}</div>
                                <p className={styles.text}>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div
                    className={styles.looksGoodBtn}>
                    <AnimatedButton onClick={!loading ? QuickSetupGateway : null} label={!loading ? "Proceed to Checkout" : "Processing"} />
                </div>
            </div>


        </div>
    )
}

export default GetNumber
